fx.ns("shared.renderers", class SharedPhotoSelectRenderer extends shared.renderers.PhotoRenderer {
    
	constructor(data)
	{
		super(data);
	}

    
	create()
	{
		this.image = new fx.components.Image({className : "draggable", data : this.data.thumb});
		this.image.attr("data-class", "Photo");
		this.image.attr("data-id", this.data.id);
		this.image.attr("data-width", this.data.width);
		this.image.attr("data-height", this.data.height);

		this.addChild(this.image);

		this.selectedIcon = new fx.components.Image({data : fx.assets.used, className : "usedicon", tooltip : fx.text("Photo sélectionnée")});
		this.selectedIcon.visibleAtStart = this.data.selected && this.data.analysed;
		
		this.addChild(this.selectedIcon, {top:5, right:5, width:40, height:40});
	}

	onReady()
	{
		super.onReady();

		if (fx.browser.isMobile)
			this.on("tap", this.onClick, this.image);
		else
			this.on("click", this.onClick, this.image);

		//this.toolTip = "R:" + this.data.rate.toFixed(2) + "|T:" + ((Number(this.data.technicalScore) - 5)/10).toFixed(2) + "|A:" + ((Number(this.data.artisticScore) - 5)/5).toFixed(2) + "|E:" + (this.data.emotionalScore / 5).toFixed(2) + "|P:" + (this.data.people * 10).toFixed(2) + "<br>Q:" + this.data.rectFacesQuality.toFixed(2) + "|B:" + this.data.brightness.toFixed(2) + "|C:" + (this.data.colorfulness / 100).toFixed(2)+"|Bad :" + this.data.badQuality + "<br>"+this.data.date_taken;
	}


	onDataUpdated(action)
	{
		if (!this.initialized) return;

		this.toggleClass("analysed", this.data.analysed);

			if (this.data.selected)
			{
				this.selectedIcon.show();
				this.image.addClass("selected");
			}
			else
			{
				this.selectedIcon.hide();
				this.image.removeClass("selected");
			}
	}


	onMouseOver()
	{
		
	}

	onMouseOut()
	{
		
	}

	onClick()
	{
		this.data.selected = this.data.selected ? 0 : 1;
	}
});